import { render } from "./EditOrAddModal.vue?vue&type=template&id=035da406&ts=true"
import script from "./EditOrAddModal.vue?vue&type=script&lang=ts"
export * from "./EditOrAddModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__